<template>
  <div class="row servicePage">
    <div class="col-md-12">
      <List
        :__list="dataArray"
        :__isOnLoad="isListOnload"
        :__editMode="false"
        :__idxOnEdition="-1"
        :__isLightMode="this.isLightMode"
        :__devisIDs="this.devisIDs"
        :__onSelect="this.onSelect"
        ></List>
    </div>

    <transition name="serviceEditorOverlay">
      <div
        v-if="onEditionId !== null"
        class="serviceEditorBackdrop"
        @click="cancelAction"
      ></div>
    </transition>

    <transition name="serviceEditorDrawer">
      <div
        v-if="onEditionId !== null"
        class="serviceEditorDrawer"
        @click.stop
      >
        <div class="serviceEditorHead">
          <div>
            <div class="serviceEditorTitle">
              {{ onEditionIdx === -1 ? 'Nouveau service' : 'Modifier service' }}
            </div>
          </div>
          <button type="button" class="serviceEditorClose" @click="cancelAction">×</button>
        </div>

        <Edit
          :__item="onEditionItem"
          :__isOnLoad="isEditOnload"
        ></Edit>
      </div>
    </transition>
  </div>
</template>
<script>
import Edit from './Edit';
import List from './List';
export default {
  components: {
    Edit,
    List,
  },
  props: {
    isLightMode:  {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    devisIDs: {
      type: Array,
      default: () => {
        return [];
      },
    },

    onSelect: {
        type: Function,
        default: () => {()=>{}},
      },
  },

  data() {
    return {
      moduleRoute: '/services',
      onEditionId: null,
      onEditionIdx: -1,
      onEditionItem: null,
      isListOnload: false,
      isEditOnload: false,
      dataArray: [],
      onGoingReq:[],
    };
  },

  methods: {
    createEmptyItem() {
      return {
        name: '',
        desc: '',
        ref: '',
        catID: '',
        prixA: 0,
        prixV: 0,
        pic: '',
        isActive: 1,
      };
    },

    cancelAction() {
      this.onEditionId = null;
      this.onEditionIdx = -1;
      this.onEditionItem = null;
    },

    // patch() {
    //   this.__.httpAction({
    //     server: 'http://localhost/newProject/toolza/__utils/_php/',
    //     methode: 'GET',
    //     route: '__getterPatch.php',
    //     data: {},
    //     onComplete: ()=> {},
    //     onError: ()=> {},
    //     onNext: (res) => {
    //      res.data.map(e => {
    //       this.__.httpAction({
    //         methode: 'PUT',
    //         route: this.moduleRoute,
    //         data: {},
    //         onNext: (response)=> {
    //           var data =  { ...e,  _id: response.data}
    //           this.updateAction({ onComplete:()=>{},onError:()=>{},onNext:()=>{}, data });
    //         },
    //         onError: ()=>{},
    //         onComplete: ()=>{},
    //       });
    //      })
    //     },
    //   });
    // },

    updPriceAction(itm) {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(itm._id, null, -1);
      };
      
      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      var data = {
        _id: itm._id,
        prixV: itm.newPrice
      }
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    saveAction() {
      if (this.onEditionId === '__draft__') {
        this.createAction();
        return;
      }

      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(this.onEditionId, null, this.onEditionIdx);
      };
      
      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      let diff = this.__.differ(
        this.dataArray[this.onEditionIdx],
        this.onEditionItem
      );
      diff.push('_id');
      let data = this._.pick(this.onEditionItem, diff);
      
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    toggleActivateAction(id, val) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx].isActive = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', 'isActive']);
      data.isActive = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    editAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx)
      this.onEditionId = id;
      this.onEditionIdx = idx;
      this.onEditionItem = this._.omit(this.dataArray[idx]);
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    createAction() {
      this.onGoingReq.push({});
      const $onNext = (response) => {
        this.loadData(response.data, () => {
          this.editAction(response.data);
        });
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      const data = this._.omit({ ...this.onEditionItem }, ['_id']);
      this.__.httpAction({
        methode: 'PUT',
        route: this.moduleRoute,
        data,
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    addAction() {
      this.onEditionId = '__draft__';
      this.onEditionIdx = -1;
      this.onEditionItem = this.createEmptyItem();
    },

    loadData(id = null, cb = null, putAt = null) {
      let $onNext = (response) => {
        if (id != null) {
          if (putAt != null) {
            if(putAt === -1) {
              const idx = (element) => element._id === id;
              var position = this.dataArray.findIndex(idx)
              console.log(position );
              this.dataArray[position] = response.data[0];
            } else {
              this.dataArray[putAt] = response.data[0];
            }
            
          } else {
            this.dataArray.unshift(response.data[0]);
          }

          if (cb) cb();
        } else {
          this.dataArray = response.data;
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: this.moduleRoute+ (id != null ? '/'+id : '/'),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
    
  },
  mounted() {
    
    this.loadData();
  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
  },
};
</script>
<style scoped>
.servicePage {
  position: relative;
}

.serviceEditorBackdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.2);
  z-index: 336;
}

.serviceEditorDrawer {
  position: fixed;
  top: 175px;
  left: 50%;
  width: min(760px, calc(100vw - 48px));
  max-height: calc(100vh - 195px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 18px;
  border-radius: 20px;
  background: #eef1f5;
  box-shadow: 0 24px 55px rgba(15, 23, 42, 0.22);
  border: 1px solid rgba(226, 232, 240, 0.95);
  z-index: 337;
  transform: translateX(-50%);
}

.serviceEditorHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.serviceEditorTitle {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.serviceEditorClose {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 999px;
  background: #ffffff;
  color: #334155;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
}

.serviceEditorDrawer-enter-active,
.serviceEditorDrawer-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.serviceEditorDrawer-enter,
.serviceEditorDrawer-leave-to {
  transform: translate(-50%, 24px) scale(0.985);
  opacity: 0;
}

.serviceEditorOverlay-enter-active,
.serviceEditorOverlay-leave-active {
  transition: opacity 0.22s ease;
}

.serviceEditorOverlay-enter,
.serviceEditorOverlay-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .serviceEditorDrawer {
    top: 110px;
    width: calc(100vw - 20px);
    max-height: calc(100vh - 125px);
    padding: 14px;
    border-radius: 16px;
  }
}
</style>
<style></style>
